import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { useAuthenticator, Authenticator } from '@aws-amplify/ui-react';
import { updateApiConfigAndLogger } from 'config/api';
import clientAuth from 'config/clientAuth';

import { MuiThemeProvider } from '@material-ui/core';
import theme from 'theme';

import { createLogger, LoggerContextProvider } from './utils/logger';
import { ConfigurationContextProvider } from './utils/config';
import { ConfigurationLoader } from './components/ConfigurationLoader';
import Notification from './components/Notification';
import App from './App.container';
import WithApolloProvider from './components/WithApolloProvider';
import AuthLogin from './components/Login';

/** Code upgraded the flow has been changed with useAuthenticator */
// const AppWithAuth = withAuthenticator(App, false, [<AuthLogin />]);

function Routing(props) {
  const { config, logger } = props;
  const { authStatus } = useAuthenticator((context) => [context.user]);
  return (
    <Router>
      <MuiThemeProvider theme={theme}>
        <ConfigurationContextProvider value={config}>
          <LoggerContextProvider value={logger}>
            <WithApolloProvider config={config}>
              {authStatus !== 'authenticated' ? <AuthLogin /> : <App />}
              <Notification />
            </WithApolloProvider>
          </LoggerContextProvider>
        </ConfigurationContextProvider>
      </MuiThemeProvider>
    </Router>
  );
}

export default () => (
  <ConfigurationLoader>
    {(config, configMetaData) => {
      // Initialize AWS Amplify Auth
      const authConfig = config.get('Auth');

      Amplify.configure({ Auth: authConfig });

      clientAuth.configure({ Auth: config.get('clientAuth.NM') });

      // Initial app logger
      const logger = createLogger(config.get('logger'));

      // TODO: tmp solution
      updateApiConfigAndLogger(config, logger, configMetaData);

      return (
        <Authenticator.Provider>
          <Routing config={config} logger={logger} />
        </Authenticator.Provider>
      );
    }}
  </ConfigurationLoader>
);
